import {
  Heading,
  Modal,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import ButtonMinor from '../../../components/ButtonMinor';
import RadioButtonGroup from '../../../components/RadioButtonGroup';
import {
  sendAudioClick,
  sendWorldCreate,
} from '../../../vuplex';
import {
  fontFamily,
  getWorldTypeAccentColor,
  newCraterRunRoomName,
  newSpaceportRoomName,
  worldTypes,
} from './config';
import Emoji from './Emoji';

const NewWorldModal = ({isOpen, onClose, worldType}) => {
  const [isPrivate, setIsPrivate] = useState(false);

  useEffect(() => {
    setIsPrivate(false);
  }, [isOpen]);

  const handleConfirmClick = (evt) => {
    sendWorldCreate({
      isPrivate,
      worldType,
    });
    sendAudioClick(evt);
    onClose();
  };

  const isCraterRun = worldType === worldTypes.craterRun;

  const newWorld = {
    name: isCraterRun ? newCraterRunRoomName : newSpaceportRoomName,
    participants: {},
    isPrivate: false,
    rules: {
      worldType,
    },
  };

  const accentColor = getWorldTypeAccentColor(newWorld);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
    >
      <ModalOverlay
        background="none"
      />

      <ModalContent
        bg="black"
        borderRadius="none"
        borderColor={accentColor}
        borderWidth={4}
        marginBottom="0.5rem"
        fontFamily={fontFamily}
        p={4}
      >
        <Stack gap={4} justifyContent="center">
          <Heading
            color={accentColor}
            fontFamily={fontFamily}
            size="sm"
            textAlign="center"
          >
            Create {isCraterRun ? 'Race Room' : 'Spaceport'}
          </Heading>
          <RadioButtonGroup
            groupName="privacy-options"
            justifyContent="center"
            options={[
              {
                activeBg: 'privateOrange',
                borderRadius: 'none',
                isRound: false,
                label: 'Private',
                tooltip: 'Only invited people can join',
                value: true,
                w: '50%',
              },
              {
                activeBg: 'publicGreen',
                borderRadius: 'none',
                isRound: false,
                label: 'Public',
                tooltip: 'Anyone can join',
                value: false,
                w: '50%',
              },
            ]}
            onChange={setIsPrivate}
            value={isPrivate}
          />

          <ButtonMinor
            bg={accentColor}
            color="black"
            borderRadius="none"
            h="4em"
            onClick={handleConfirmClick}
            tooltip="Join room."
          >
            <Emoji>✔</Emoji>&nbsp;Create {isCraterRun ? newCraterRunRoomName : newSpaceportRoomName}
          </ButtonMinor>

          <ButtonMinor
            bg="grey"
            borderRadius="none"
            h="4em"
            onClick={() => {
              onClose();
            }}
          >
            <Emoji>✖</Emoji>&nbsp;Cancel
          </ButtonMinor>

          <Text color="white" fontSize="xs" textAlign="center">
            {isPrivate ? 'PRIVATE ROOMS CAN BE JOINED BY INVITE CODE.' : 'PUBLIC ROOMS APPEAR IN THIS LIST.'}
          </Text>
        </Stack>
      </ModalContent>
    </Modal>
  );
};

export default NewWorldModal;
